import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule} from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { Buildings } from './buildings/buildings';
import { ProvidersComponent } from './settings.component';
import { AuthGuard } from '../guards/auth.guard';
import { SaveGuard } from '../guards/save.guard';
import { VarModule } from '../directives/ngVar';
import { ListingModule } from '../components/listing/listing.module';
import { DirectivesModule } from '../directives/directive.module';
import { PractitionerGroupsModule } from './practitionerGroups/practitionerGroups.module';
import { DocumentsModule } from '../components/documents/documents.module';
import { ProviderEndpointsModule } from './provider-endpoints/provider-endpoints.module';
import { MatIconModule } from '@angular/material/icon';
import { ServiceLevelsModule } from './service-levels/service-levels.module';
import { ChecklistTemplatesModule } from './checklist-templates/checklist-templates.module';
import { ProviderCleanerModule } from './provider-cleaner/provider-cleaner.module';
import { EvaluationsComponentModule } from './evaluations/evaluations.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    DirectivesModule,
    DocumentsModule,
    EvaluationsComponentModule,
    VarModule,
    ListingModule,
    Buildings,
    PractitionerGroupsModule,
    ProviderEndpointsModule,
    ChecklistTemplatesModule,
    ProviderCleanerModule,
    ServiceLevelsModule,
    RouterModule.forChild([
      {
        path: 'settings',
        canActivate: [AuthGuard],
        canDeactivate: [SaveGuard],
        component: ProvidersComponent,
        children: []
      }
    ])
  ],
  declarations: [
    ProvidersComponent
  ],
  exports: [
    ProvidersComponent
  ]
})
export class SettingsModule { }
